import React from 'react'

// either import from the outside (long-term: module, maybe npm?)
// or define here (only for some quick hacks...)

import { QuickSortPresentation } from './QuickSortPresentation';

interface IQuickSortContainerProps {
  Numbers: Array<number> | undefined,
  StepName: string | undefined,
  HI: number | undefined,
  LO: number | undefined,
  ICount: number | undefined,
  JCount: number | undefined,
  Pivot: number | undefined,
  PartitionIndex: number | undefined,
  SortedIndices: Array<number> | undefined,
  StepForward: () => void,
  StepBackward: () => void,
}

function QuickSortContainer ({
  StepForward,
  StepBackward,
  StepName,
  Numbers,
  LO,
  HI,
  Pivot,
  ICount,
  JCount,
  PartitionIndex,
  SortedIndices,
} : IQuickSortContainerProps) {

  return (
    <QuickSortPresentation
      StepName={StepName}
      Numbers={Numbers}
      LO={LO} 
      HI={HI}
      Pivot={Pivot}
      ICount={ICount}
      JCount={JCount}
      PartitionNumber={PartitionIndex}
      StepForward={StepForward}
      StepBackward={StepBackward}
      SortedIndices={SortedIndices}
    />
  )
}

export { QuickSortContainer };